.copyinput {
  border: none;
  border-radius: 1rem 0rem 0rem 1rem;
  background-color: #eee;
  font-family: monospace;
  font-size: 0.8rem;
}

.copybutton,
.copyinput {
  border: 1px solid #666;
  margin-left: 0.2rem;
  font-family: monospace;
}

.copybutton:hover,
.copyinput:hover {
  border: 1px solid #66f;
}
